import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginationInput } from '@/models/app';

export const getPartnerActiveRides = async ({ partnerId, pagination }: { partnerId: number; pagination: PaginationInput }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      partnerId,
      pagination,
    },
    query: graphql(`
      query GetPartnerActiveRides($partnerId: Float!, $pagination: PaginationInputType) {
        getPartnerActiveRides(partnerId: $partnerId, pagination: $pagination) {
          count
          rows {
            id
            requestId
            createdAt
            timeAccepted
            timeArriving
            timeInProgress
            riderPhone
            startLocation
            gogoMap
            endLocation
            distance
            duration
            gogoCost
            customerCost
            customerCredits
            partnerCost
            partnerCredits
            surgeFactor
            driverPhone
            caller {
              firstName
              lastName
            }
          }
        }
      }
    `),
  });

  return response.data.getPartnerActiveRides;
};
